import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'lc-display-1',
            'lc-display-2',
            'lc-headline-1',
            'lc-headline-2',
            'lc-headline-3',
            'lc-headline-4',
            'lc-body-1',
            'lc-body-2',
            'lc-body-3',
            'lc-caption-1',
            'lc-v3-display-1',
            'lc-v3-display-2',
            'lc-v3-h1',
            'lc-v3-h2',
            'lc-v3-h3',
            'lc-v3-h4',
            'lc-v3-h5',
            'lc-v3-body-1',
            'lc-v3-body-2',
            'lc-v3-caption-1',
            'lc-v3-caption-2',
            'lc-v3-overline',
            'lc-v3-label-lg',
            'lc-v3-label-md',
            'lc-v3-label-sm',
            'qb-display-1',
            'qb-display-2',
            'qb-h1',
            'qb-h2',
            'qb-h3',
            'qb-h4',
            'qb-h5',
            'qb-body-1',
            'qb-body-2',
            'qb-body-3',
            'qb-body-4',
            'qb-body-5',
          ],
        },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
